// internationalization
import type { TFunction } from 'i18next';

// shared components
import type { DanishAddressFieldValue } from '@/components/ui/form';

// libraries
import { z } from 'zod';

const openingHoursDaySchema = z.array(
  z.object({ start: z.number(), end: z.number() }),
);

export const openingHoursSchema = z.object({
  monday: openingHoursDaySchema,
  tuesday: openingHoursDaySchema,
  wednesday: openingHoursDaySchema,
  thursday: openingHoursDaySchema,
  friday: openingHoursDaySchema,
  saturday: openingHoursDaySchema,
  sunday: openingHoursDaySchema,
});

export type OpeningHoursValue = z.infer<typeof openingHoursSchema>;

export function createEditEnergyGroupFormSchema(t: TFunction) {
  return z.object({
    name: z.string().min(1, t('input.required', { ns: 'validation' })),
    location: z
      .custom<DanishAddressFieldValue>()
      .refine(
        (value) =>
          Boolean(value?.displayName?.trim()) &&
          Number.isFinite(value?.latitude) &&
          Number.isFinite(value?.longitude),
        { message: t('input.required', { ns: 'validation' }) },
      ),
    openingHours: openingHoursSchema,
  });
}

export type EditEnergyGroupFormValues = z.infer<
  ReturnType<typeof createEditEnergyGroupFormSchema>
>;
